import { isoAndUnixZodSchema } from "@@/shared/date-time/iso-and-unix";
import { orderGroupIdZodSchema } from "@@/shared/order-groups/order-group-id";
import { orderEventIdZodSchema } from "@@/shared/orders/order-events/events/_order-event-id";
import { orderIdZodSchema } from "@@/shared/orders/order-id";
import { paymentProviderZodSchema } from "@@/shared/payments/payment-providers";
import { priceZodSchema } from "@@/shared/prices/price";
import { providerIdZodSchema } from "@@/shared/providers/provider-id";
import { translatableZodSchema } from "@@/shared/translations/translation";
import { z } from "zod";
import { payRequestEventIdZodSchema } from "../../events/_pay-request.event-id";
import { payRequestIdZodSchema } from "../../pay-request-id";
import { payRequestPaymentIdZodSchema } from "../../pay-request-payment-id";

const payRequestStatusProjectionZodObject = z.object({
    _id: payRequestIdZodSchema,
    _type: z.literal("PAY_REQUEST_PAYMENT_STATUS_PROJECTION"),
    _createdAt: isoAndUnixZodSchema,
    _version: z.number(),
    status: z.enum(["PENDING", "CANCELLED", "EXPIRED", "FULFILLED"]),
    amountUnpaid: priceZodSchema,
    payRequestFor: z.object({
        orderId: orderIdZodSchema,
        orderGroupId: orderGroupIdZodSchema,
        providerId: providerIdZodSchema,
        orderEventIds: z.array(orderEventIdZodSchema),
    }),
    replacedBy: payRequestIdZodSchema.optional(),
    /**
     * When someone initiates an attempt to pay the pay request,
     * payment events are created to follow the payment process(es)
     * E.g. the first attempt could fail, then the payer could try again
     * and more payment events would be created
     */
    paymentEvents: z.array(
        z.object({
            _id: payRequestEventIdZodSchema,
            _createdAt: isoAndUnixZodSchema,
            _happenedAt: isoAndUnixZodSchema,
            paymentId: payRequestPaymentIdZodSchema,
            paymentProvider: paymentProviderZodSchema,
            status: z.enum([
                "PENDING",
                "CANCELLED",
                "FAILED",
                "EXPIRED",
                "FULFILLED",
            ]),
            reason: translatableZodSchema.optional(),
        }),
    ),
});

type PayRequestStatusProjection = z.infer<
    typeof payRequestStatusProjectionZodObject
>;
const payRequestStatusProjectionZodSchema: z.ZodSchema<PayRequestStatusProjection> =
    payRequestStatusProjectionZodObject;

export {
    payRequestStatusProjectionZodObject,
    payRequestStatusProjectionZodSchema,
};
export type { PayRequestStatusProjection };
